import styled from 'styled-components';
import { HomePageOptionsStyled } from '../HomePageOptionsStyled';

export const HomePageOptionsStyledOV = styled(HomePageOptionsStyled)`
    .homepage-headline {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }
`;
